import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataUser(params) {
	return client.get("api/user/data", {
		params: params,
	});
}

function getDataUserAll(params) {
	return client.get("api/user/all", {
		params: params,
	});
}

function exportUser(params) {
	return client.get("api/user/export", {
		params: params,
	});
}

function exportUserAll(params) {
	return client.get("api/user/export-all", {
		params: params,
	});
}

function getOptionWarehouseAll() {
	return client.get("api/options/warehouse-all");
}

function getOptionType() {
	return client.get("api/options/user-type");
}

function addUser(params) {
	return client.post("api/user/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function addUserAll(params) {
	return client.post("api/user/addAll", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateUser(params) {
	return client.post("api/user/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateUserAll(params) {
	return client.post("api/user/editAll", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteUser(params) {
	return client.post("api/user/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function statusUser(params) {
	return client.post("api/user/status", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function changeImage(params) {
	return client.post('api/user/image', params, {
		header: {
			'Content-Type': 'multipart/form-data'
		},
	});
}

function changePassword(params) {
	return client.post("api/user/edit-password", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function changePasswordAll(params) {
	return client.post("api/user/edit-password-all", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getDataUser,
	getDataUserAll,
	exportUser,
	exportUserAll,
	addUser,
	addUserAll,
	updateUser,
	updateUserAll,
	deleteUser,
	statusUser,
	getOptionWarehouseAll,
	getOptionType,
	changeImage,
	changePassword,
	changePasswordAll
};